// Chiavi di archiviazione locale del browser (preferenze dell'utente, solo se
// le sceglie). Prefisso `aiposto:`; le vecchie chiavi `prenotami:*` vengono
// migrate una volta all'avvio, senza perdere le preferenze gia' espresse.
export const KEYS = {
  theme: "aiposto:theme",
  fontSize: "aiposto:font-size",
  sidebarCollapsed: "aiposto:sidebar-collapsed",
  calendarView: "aiposto:calendar-view",
};

export const selectedLocationKey = (businessId) => `aiposto:selected-location:${businessId}`;

const LEGACY_PREFIX = "prenotami:";
const NEW_PREFIX = "aiposto:";

export function migrateLegacyKeys(storage) {
  try {
    const legacy = [];
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (key && key.startsWith(LEGACY_PREFIX)) legacy.push(key);
    }
    for (const key of legacy) {
      const target = NEW_PREFIX + key.slice(LEGACY_PREFIX.length);
      if (storage.getItem(target) === null) storage.setItem(target, storage.getItem(key));
      storage.removeItem(key);
    }
  } catch {
    /* storage non disponibile (privacy mode): nessun impatto funzionale */
  }
}
